<p class="title">Your local area</p>
<div class="block has-text-centered py-2">
  <p>
    Donations made
    {#if $appState.company?.area}
      in {$appState.company.area}
    {/if}
  </p>
  <p style="font-size:6rem;">
    {#if areaCount !== undefined}{areaCount}{:else}0{/if}
  </p>
  <p class="has-text-grey-light">
    {#if areaCountMessage[areaCount || 0]}
      {@html areaCountMessage[areaCount || 0]}
    {:else}
      We're on a roll! Can you help with <a href={$url('../offers/create')}
        >one more</a
      >?
    {/if}
  </p>
</div>

<script lang="ts">
  import { url, goto } from '@sveltech/routify';
  import { appState } from '../../../../lib/appState';

  let firebase = window.firebase;

  let areaCount: number;

  const areaCountMessage: any = {
    0: `That means you can <a href="${$url(
      '../offers/create'
    )}">be the first</a>!`,
    1: `We're off the mark! <a href="${$url(
      '../offers/create'
    )}">Let's get another</a>.`,
    9: `Nearly double figures! <a href="${$url(
      '../offers/create'
    )}">We just need one more</a>.`
  };

  let hasRun1 = false;
  $: if ($appState.company?.area && !hasRun1) {
    hasRun1 = true;
    getAreaCount($appState.company.area);
  }

  async function getAreaCount(area: string) {
    firebase
      .firestore()
      .collection('areas_v1')
      .doc(area)
      .onSnapshot((doc) => {
        areaCount = doc?.data()?.offersCompleted;
      });
  }

</script>
